import type { RefObject } from 'react';
import type { ButtonGridItemRef } from './button-grid-item/ButtonGridItem.data';
import type { HeadingRef } from '../../atoms/heading/Heading.data';
import { findTransitionController } from '../../../util/core-transition-component';

interface ButtonGridRefs {
  elementRef?: RefObject<HTMLElement | null>;
  titleRef?: RefObject<HeadingRef | null>;
  itemsRef?: RefObject<Array<RefObject<ButtonGridItemRef | null>> | null>;
  backgroundRef?: RefObject<HTMLDivElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { itemsRef, titleRef, backgroundRef }: ButtonGridRefs,
): void {
  if (backgroundRef?.current) {
    timeline.fromTo(
      backgroundRef.current,
      { scaleX: 0 },
      {
        scaleX: 1,
        clearProps: 'scaleX',
        duration: 0.5,
        ease: 'Quad.easeInOut',
      },
      0,
    );
  }

  if (titleRef?.current) {
    const titleController = findTransitionController(titleRef);
    timeline.add(titleController?.getTimeline('in') as gsap.core.Timeline, 0.2);
  }

  itemsRef?.current?.forEach((itemRef, index) => {
    const itemController = findTransitionController(itemRef);
    if (itemController) {
      timeline.add(itemController.getTimeline('in') as gsap.core.Timeline, 0.3 + index * 0.075);
    }
  });
}
